import React, { useState } from 'react';
import './AboutUs.css';

const AboutUs = () => {
  const [aboutContent, setAboutContent] = useState({
    title: 'About Us',
    description: '', // Added description
  });

  const [whyConnectContent, setWhyConnectContent] = useState({
    title: 'Why Startup Connect',
    description: '', // Added description
  });

  const [features, setFeatures] = useState([
    {
      title: 'Advanced Search Capabilities',
      points: ['', '', ''],
    },
    {
      title: 'Real-Time Updates',
      points: ['', '', ''],
    },
    {
      title: 'Investment and Networking Opportunities',
      points: ['', '', ''],
    },
  ]);

  const [additionalInfo, setAdditionalInfo] = useState({
    title: 'About Startup Connect',
    buttonText: 'Register here',
    description: '', // Added description
    contactNumber: '', // Default contact number
    contactEmail: '', // Added contact email
  });

  const handleAboutContentChange = (field, value) => {
    setAboutContent({ ...aboutContent, [field]: value });
  };

  const handleWhyConnectContentChange = (field, value) => {
    setWhyConnectContent({ ...whyConnectContent, [field]: value });
  };

  const handleFeatureChange = (index, pointIndex, value) => {
    const updatedFeatures = [...features];
    updatedFeatures[index].points[pointIndex] = value;
    setFeatures(updatedFeatures);
  };

  const handleAdditionalInfoChange = (field, value) => {
    setAdditionalInfo({ ...additionalInfo, [field]: value });
  };

  const updateAboutUs = () => {
    console.log('Updated About Us:', { aboutContent, whyConnectContent, features, additionalInfo });
    alert('About Us section updated successfully!');
  };

  return (
    <div className="aboutus-container">
      <h2>Update About Us Section</h2>

      <div className="section">
        <label>{aboutContent.title}</label>
        <textarea
          value={aboutContent.description}
          onChange={(e) => handleAboutContentChange('description', e.target.value)}
        />
      </div>

      <div className="section">
        <label>{whyConnectContent.title}</label>
        <textarea
          value={whyConnectContent.description}
          onChange={(e) => handleWhyConnectContentChange('description', e.target.value)}
        />
      </div>

      <h3>Features</h3>
      {features.map((feature, index) => (
        <div key={index} className="feature-section">
          <label>{feature.title}</label>
          {feature.points.map((point, pointIndex) => (
            <textarea
              key={pointIndex}
              value={point}
              onChange={(e) => handleFeatureChange(index, pointIndex, e.target.value)}
            />
          ))}
        </div>
      ))}

      <div className="section">
        <label>{additionalInfo.title}</label>
        <textarea
          value={additionalInfo.description}
          onChange={(e) => handleAdditionalInfoChange('description', e.target.value)}
        />
        <label>Contact Number</label>
        <input
          type="text"
          value={additionalInfo.contactNumber}
          onChange={(e) => handleAdditionalInfoChange('contactNumber', e.target.value)}
        /> 
      </div>

      <button className="update-btn" onClick={updateAboutUs}>Update About Us</button>
    </div>
  );
};

export default AboutUs;
